import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as DOWN } from "../../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../../assets/icons/filter-up.svg";
import "./SelectClient.css";
import "../../Account/OrdersComponents/TranslatorDropdown.css";

function SelectClient({ clients, customClass, handleSelectedClient, defaultSelecedClient, placeholder = "Choose Client", autoFocus = true}) {
  const [selectedClient, setSelectedClient] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Add search term state
  const dropdownRef = useRef(null);

  useEffect(() => {
    if(defaultSelecedClient && defaultSelecedClient.id){
      setSelectedClient(defaultSelecedClient.id)
    }
  }, [defaultSelecedClient])

  const handleSelect = (selectedValue) => {
    setSelectedClient(selectedValue);
    setIsOpen(false);
    const data = clients.find((el) => el.id === selectedValue);
    if (data) {
      // const fullName = data.firstName + " " + data.lastName;
      handleSelectedClient(data);
    } else {
      console.log("No matching data found");
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter clients based on search term
  const filteredClients = (clients || []).filter(
    (client) =>
      client.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className={`relative cursor-pointer max-w-[450px] w-full`}
      ref={dropdownRef}
    >
      <div
        className={`custom-dropdown-header ${customClass} ${
          isOpen && "active"
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedClient
          ? (() => {
              const selected = clients.find((el) => el.id === selectedClient);
              return selected ? (
                <div className="selected-client">
                  <span className="selected-client-name">{selected.name}</span>
                  <span className="selected-client-email">
                    {selected.email}
                  </span>
                </div>
              ) : (
                placeholder
              );
            })()
          : placeholder}
        {isOpen ? (
          <UP className="dropdown-icon" />
        ) : (
          <DOWN className="dropdown-icon" />
        )}
      </div>
      {isOpen && (
        <div className="custom-dropdown-options absolute top-full left-0 right-0 z-10 w-full max-h-[280px] overflow-y-auto bg-white">
          <div className="sticky top-0 w-full bg-white">
            <input
              type="search"
              className="custom-dropdown-search outline-none"
              placeholder="Search by name or email"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus={autoFocus}
            />
          </div>
          {filteredClients.length > 0 ? (
            filteredClients.map((t) => (
              <div
                key={t.id}
                className="custom-dropdown-option"
                onClick={() => handleSelect(t.id)}
              >
                <div className="dropdown-item-name">{t.name || (t.firstName + " " + t.lastName)}</div>
                <div className="dropdown-item-email">{t.email}</div>
              </div>
            ))
          ) : (
            <div className="custom-dropdown-no-results">No results found</div>
          )}
        </div>
      )}
    </div>
  );
}

export default SelectClient;
